export const DEFAULT_APPLICATION_TARGETS = {
  vehicleTrack: { id: "vehicleTrack", route: "/dashboard" },
  schoolTrack: { id: "schoolTrack", route: "/school" },
};

export const normalizeDefaultApplication = (value) => {
  if (!value && value !== 0) return null;

  const normalizedValue = String(value).trim().toLowerCase();

  if (!normalizedValue) return null;

  if (["vehicletrack", "fleet", "fleetmanagement", "fleet-management", "vehicle"].includes(normalizedValue)) {
    return "vehicleTrack";
  }

  if (["schooltrack", "school", "schoolbus", "school-bus"].includes(normalizedValue)) {
    return "schoolTrack";
  }

  return null;
};

export const getDefaultApplicationValue = (settings = {}) => {
  const rawValue =
    settings?.defaultApplication ||
    settings?.default_app ||
    settings?.defaultApp ||
    settings?.defaultApplicationValue;

  return normalizeDefaultApplication(rawValue);
};

export const getDefaultApplicationTarget = (value) => {
  const normalizedValue = normalizeDefaultApplication(value);
  if (!normalizedValue) return null;

  return DEFAULT_APPLICATION_TARGETS[normalizedValue] || null;
};

export const getDefaultApplicationOptions = (organizationTypes = []) => {
  const normalizedTypes = Array.isArray(organizationTypes)
    ? organizationTypes
    : organizationTypes
      ? [organizationTypes]
      : [];

  const options = [];

  if (normalizedTypes.includes("vehicleTrack")) {
    options.push({ code: "vehicleTrack", name: "Fleet Management System" });
  }

  if (normalizedTypes.includes("schoolTrack")) {
    options.push({ code: "schoolTrack", name: "School Bus Tracking" });
  }

  return options;
};
